




















import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * Mixins
 */
import mixinsDate from "@/mixins/date-mixins";

/**
 * API
 */
import adminAPI, { FilteredResponseModel } from '@/api/admin';

/**
 * Components
 */


/**
 * Page des historiques détaillés de synchronisation.
 */
@Component({ mixins: [mixinsDate] })
export default class SynchronizationHistoryPage extends Vue {
	/** Injections */
	getSynchronizationLogsList = adminAPI.getSynchronizationLogsList;

	/** Attributs */
	isLoading = false;
	synchronizationLogsList: FilteredResponseModel<any> | null = null;
	pagination = {
		sortBy: 'id',
		descending: true,
	};
	headers = [
		{
			text: 'synchronization.id',
			value: 'id',
			align: 'left'
		},
		{
			text: 'synchronization.start_date',
			value: 'startDate',
			align: 'left'
		},
		{
			text: 'synchronization.end_date',
			value: 'endDate',
			align: 'left'
		},
		{
			text: '',
			value: 'isOk',
			align: 'center'
		}
	];

	/** Méthodes */
	async created() {
	}
}
